import base from './base2.repository';
export default {
    get: (params) => base.get('business-lines', params)
}